import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

export function CardProductsList({ children, itemClassName }) {
    children = React.Children.toArray(children);

    return (
        <ul className={styles.root}>
            {children.map((item, key) => (
                <li className={itemClassName ? itemClassName : ''} key={key}>
                    {item}
                </li>
            ))}
        </ul>
    );
}

CardProductsList.propTypes = {
    children: PropTypes.node,
    itemClassName: PropTypes.string,
};
